import React from "react";

interface SkeletonProps {
    className: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
    return (
        <div className={ className }>
            <div className="bg-[#ebebeb] rounded-full w-full h-full"/>
        </div>
    );
}